import { DeleteIcon } from '@approvalmax/ui';
import { Button, Flex, TextField } from '@approvalmax/ui/src/components';
import { domain } from 'modules/data';
import { memo } from 'react';

import { actionsRightWidth } from '../../ReportSchedulerPopup.constants';
import { CustomMonthlyScheduleOption } from '../CustomMonthlyScheduleOption/CustomMonthlyScheduleOption';
import { CustomScheduleTypeSelector } from '../CustomScheduleTypeSelector/CustomScheduleTypeSelector';
import { CustomWeeklyScheduleOption } from '../CustomWeeklyScheduleOption/CustomWeeklyScheduleOption';
import { CustomYearlyScheduleOption } from '../CustomYearlyScheduleOption/CustomYearlyScheduleOption';
import { RuleEmailsSection } from '../RuleEmailsSection/RuleEmailsSection';
import { RuleTypeSection } from '../RuleTypeSection/RuleTypeSection';
import { StandardScheduleOption } from '../StandardScheduleOption/StandardScheduleOption';
import { RuleRowProps } from './RuleRow.types';

export const RuleRow = memo<RuleRowProps>((props) => {
    const { rule, ruleIndex, onUpdate, onDelete } = props;

    const isCustom = rule.configuration.scheduleOptions === domain.ScheduleOption.Custom;
    const isWeekly = rule.configuration.customSchedulePeriodicity === domain.CustomScheduleType.Weekly;
    const isMonthly = rule.configuration.customSchedulePeriodicity === domain.CustomScheduleType.Monthly;
    const isAnnually = rule.configuration.customSchedulePeriodicity === domain.CustomScheduleType.Annually;

    return (
        <Flex direction='column' spacing='12' data-qa='rule'>
            <Flex spacing='8' alignItems='center'>
                <Flex grow={1} shrink={0}>
                    <TextField
                        data-qa='rule-name-input'
                        size='small'
                        value={rule.name}
                        onChange={(value) => onUpdate(ruleIndex, value)}
                        invalid={Boolean(rule.validationErrors.nameError) || rule.validationErrors.longRuleName}
                        placeholder={rule.validationErrors.nameError || ''}
                        maxLength={100}
                        clearable={false}
                        required
                    />
                </Flex>

                <Flex grow={0} shrink={0} width={actionsRightWidth} justifyContent='end'>
                    <Button
                        icon
                        noPadding
                        data-qa='remove-rule-button'
                        onClick={() => onDelete(ruleIndex)}
                        variant='text'
                        color='blue100'
                    >
                        <DeleteIcon size={20} />
                    </Button>
                </Flex>
            </Flex>

            <RuleEmailsSection ruleIndex={ruleIndex} />

            <RuleTypeSection ruleIndex={ruleIndex} />

            {!isCustom && <StandardScheduleOption ruleIndex={ruleIndex} />}

            {isCustom && <CustomScheduleTypeSelector ruleIndex={ruleIndex} />}

            {isCustom && isWeekly && <CustomWeeklyScheduleOption ruleIndex={ruleIndex} />}

            {isCustom && isMonthly && <CustomMonthlyScheduleOption ruleIndex={ruleIndex} />}

            {isCustom && isAnnually && <CustomYearlyScheduleOption ruleIndex={ruleIndex} />}
        </Flex>
    );
});

RuleRow.displayName = 'RuleRow';
